
import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastItem, ToastService } from '../../../service/toast.service';
import { CriticalIcon, InfoIcon, SuccessIcon, WarningIcon, type IconDef } from '../icons/icon';

@Component({
  selector: 'app-toast-reusable',
  standalone: true,
  imports: [],
  templateUrl: './toast-reusable.html'
})
export class ToastReusable {
  protected readonly toastService = inject(ToastService);
  private readonly sanitizer = inject(DomSanitizer);
  protected readonly closeIcon: IconDef = {
    svg: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2426 4.81426C12.477 4.57994 12.477 4.19996 12.2426 3.96564C12.0083 3.73133 11.6283 3.73133 11.394 3.96564L8.00005 7.35961L4.60608 3.96564C4.37176 3.73133 3.99178 3.73133 3.75747 3.96564C3.52315 4.19996 3.52315 4.57994 3.75747 4.81426L7.15143 8.20822L3.75747 11.6022C3.52315 11.8365 3.52315 12.2165 3.75747 12.4508C3.99178 12.6851 4.37176 12.6851 4.60608 12.4508L8.00005 9.05683L11.394 12.4508C11.6283 12.6851 12.0083 12.6851 12.2426 12.4508C12.477 12.2165 12.477 11.8365 12.2426 11.6022L8.84867 8.20822L12.2426 4.81426Z" fill="currentColor"/></svg>'
  };

  protected trackById(_index: number, item: ToastItem): number {
    return item.id;
  }

  protected isDetailString(detail: any): detail is string {
    return typeof detail === 'string';
  }

  getAccentColor(type: string): string {
    switch (type) {
      case 'success':
        return '#22C55E';
      case 'warning':
        return '#F59E0B';
      case 'critical':
      case 'error':
        return '#EF4444';
      case 'info':
      default:
        return '#3B82F6';
    }
  }

  getFrameColor(type: string): string {
    return this.getAccentColor(type);
  }

  getIconBgColor(type: string): string {
    switch (type) {
      case 'success':
        return '#DCFCE7';
      case 'warning':
        return '#FEF3C7';
      case 'critical':
      case 'error':
        return '#FEE2E2';
      case 'info':
      default:
        return '#DBEAFE';
    }
  }

  getIconColor(type: string): string {
    switch (type) {
      case 'info':
        return '#4F46E5';
      case 'success':
        return '#16A34A';
      case 'warning':
        return '#D97706';
      case 'critical':
      case 'error':
        return '#DC2626';
      default:
        return '#4F46E5';
    }
  }

  getIconDef(type: string): IconDef {
    switch (type) {
      case 'info':
        return InfoIcon;
      case 'success':
        return SuccessIcon;
      case 'warning':
        return WarningIcon;
      case 'critical':
      case 'error':
        return CriticalIcon;
      default:
        return InfoIcon;
    }
  }

  protected renderStatusIcon(type: string): SafeHtml {
    const icon = this.getIconDef(type);
    return this.renderIcon(icon, 16, this.getIconColor(type));
  }

  protected renderCloseIcon(): SafeHtml {
    return this.renderIcon(this.closeIcon, 16, '#0F172A');
  }

  private renderIcon(icon: IconDef, size: number, color: string | null): SafeHtml {
    let svg = icon.svg
      .replace(/width="[^"]*"/, `width="${size}"`)
      .replace(/height="[^"]*"/, `height="${size}"`);

    if (color) {
      svg = svg
        .replace(/fill="(?!none)[^"]*"/g, `fill="${color}"`)
        .replace(/stroke="(?!none)[^"]*"/g, `stroke="${color}"`);
    }

    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
}